import { webAuthnEnabled } from '~/client/config/appConfig';
import { api } from '~/client/lib/trpc';

import { useCurrentUser } from '../storeHooks';
import { useDeviceId } from '../useDeviceId';

export type UseIsUserRegisteredReturn = {
  isRegistered?: boolean;
  checkingRegistration: boolean;
};

const useHasPasskey = (): UseIsUserRegisteredReturn => {
  const deviceId = useDeviceId();

  const user = useCurrentUser();

  const { data: isRegistered, isLoading } = api.isRegistered.useQuery(
    { deviceId },
    { enabled: !!user },
  );

  return {
    isRegistered,
    checkingRegistration: isLoading,
  };
};

const useHasUserPin = (): UseIsUserRegisteredReturn => {
  const user = useCurrentUser();

  const { data: hasUserPin, isLoading } = api.hasUserPin.useQuery(undefined, { enabled: !!user });

  return {
    isRegistered: hasUserPin,
    checkingRegistration: isLoading,
  };
};

export const useIsUserRegistered = webAuthnEnabled ? useHasPasskey : useHasUserPin;
